import { fallbackValue } from "constants/fallbackConstant";

const formatTime = (timestamp) => {
  if (!timestamp) return fallbackValue;

  const options = { hour: "2-digit", minute: "2-digit", hour12: false };
  return new Date(timestamp).toLocaleTimeString([], options); // Returns "HH:mm"
};

export default formatTime;
